'use client';

import { createContext, PropsWithChildren, useCallback, useContext, useState } from 'react';

import { useEvent } from 'react-use';

import { WINDOW_EVENTS } from '@/lib/constants/post-message-types';

const TriggerContext = createContext<string | null>(null);

export function TriggerContextProvider({ children }: PropsWithChildren) {
  const [trigger, setTrigger] = useState<string | null>(null);

  const handleTrigger = useCallback((e: Event) => {
    const detail = (e as CustomEvent<{ trigger?: string }>).detail;
    setTrigger(detail?.trigger ?? null);
  }, []);

  // Pick up trigger from the initial OPENED event (sent by widget-toggle on open).
  // Trigger is NOT cleared on close to avoid UI jumps during close animation.
  useEvent(WINDOW_EVENTS.OPENED, handleTrigger);

  // Pick up trigger restored from sessionStorage (sent by widget-lifecycle on IFRAME_READY).
  // This is a dedicated event to avoid re-firing OPENED side effects (session recording, focus).
  useEvent(WINDOW_EVENTS.SET_TRIGGER, handleTrigger);

  return <TriggerContext.Provider value={trigger}>{children}</TriggerContext.Provider>;
}

export function useTriggerContext(): string | null {
  return useContext(TriggerContext);
}
